import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  FormHelperText,
  Input,
  Select,
  Box,
  Flex,
  Image,
  Text,
  Button,
  Card,
  CardBody,
  SimpleGrid,
  Textarea,
  Checkbox,
} from "@chakra-ui/react";
import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";

import axios from "axios";
import "react-calendar/dist/Calendar.css";
import Calendar from "react-calendar";
//import toast from "react-hot-toast";
import React, { useState, useEffect } from "react";
import { split } from "lodash";

const PrintData = () => {
  // const [data1, setData1] = useState(new Date());
  // console.log(data1.toDateString());
  // const [data2, setData2] = useState(new Date());
  // console.log(data2.toDateString());
  // const [total, setTotal] = useState(0);
  // const [advance, setAdvance] = useState(0);
  //let dueAmount = 0;
  const [dueAmount, setDueAmount] = useState(0);
  const [data, setData] = useState([]);
  const [disable, setDisable] = useState(false);
  const [id, setId] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [imageURL, setImageURL] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [images, setImages] = useState([]);
  const customerId = localStorage.getItem("customerId");
  const fetchData = async () => {
    try {
      const response = await axios.get(
        `https://api.rasoi.launchlysoftware.in/api/getPrintData/${customerId}`,
      );
      setData(response.data);
    } catch (error) {
      toast.error(error.message);
    }
  };
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: checked, // Set formData.halfPlate to true/false based on checkbox state
    }));
  };
  const handlePost = async () => {
    try {
      setUploading(true);

      if (!selectedFile) {
        toast.error("Please select a file to upload.");
        return;
      }

      const formData = new FormData();
      formData.append("image", selectedFile); // Ensure 'image' matches the backend field name

      const response = await axios.post(
        "https://api.rasoi.launchlysoftware.in/upload", // Corrected URL
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      const data = response.data;

      // Update state with uploaded image URL
      setImageURL(data.filename); // Adjust based on backend response
      toast.success("Image uploaded successfully");
      console.log(data, "Upload response");
    } catch (err) {
      console.error("Upload failed:", err);
      toast.error("Image upload failed. Please try again.");
    } finally {
      setUploading(false);
    }
  };

  console.log(imageURL, "imageURL");

  const [formData, setFormData] = useState({
    name: "",
    adress: "",
    phoneNo: "",
    email: "",
    acNo: "",
    ifsc: "",
    branch: "",
    website: "",
    gstNo: "",
    happyHour: false,
    happyHourDiscount: null,
    happyHourFrom: "",
    happyHourTo: "",

    image: "",
    gst: false,
    splitBill: false,
    priceAdd: false,
    priceAddPercentage: null,
    hsnView: false,
  });
  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const validateForm = () => {
    const requiredFields = ["name", "adress", "phoneNo", "email"];

    for (const field of requiredFields) {
      if (!formData[field]) {
        return false;
      }
    }
    return true;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  useEffect(() => {
    fetchData();
  }, [customerId]);
  console.log(
    data.map((i) => {
      return i;
    }),
    "data",
  );
  const convertAMPMTo24Hour = (timeStr) => {
    const [time, modifier] = timeStr.split(" ");
    let [hours, minutes] = time.split(":").map(Number);

    if (modifier === "PM" && hours < 12) {
      hours += 12;
    }
    if (modifier === "AM" && hours === 12) {
      hours = 0;
    }

    return `${hours?.toString().padStart(2, "0")}:${minutes
      ?.toString()
      .padStart(2, "0")}`;
  };
  useEffect(() => {
    if (data) {
      const print = data.map((i) => {
        return i;
      });
      setId(data[0]?._id);
      setFormData({
        name: data[0]?.name || "",
        adress: data[0]?.adress || "",
        phoneNo: data[0]?.phoneNo || "",
        email: data[0]?.email || "",
        acNo: data[0]?.acNo || "",
        ifsc: data[0]?.ifsc || "",
        branch: data[0]?.branch || "",
        website: data[0]?.website || "",
        gstNo: data[0]?.gstNo || "",
        gst: data[0]?.gst || false,
        happyHour: data[0]?.happyHour || false,
        happyHourDiscount: data[0]?.happyHourDiscount || null,
        happyHourFrom: data[0]?.happyHourFrom
          ? convertAMPMTo24Hour(data[0]?.happyHourFrom)
          : "",
        happyHourTo: data[0]?.happyHourTo
          ? convertAMPMTo24Hour(data[0]?.happyHourTo)
          : "",
        priceAdd: data[0]?.priceAdd || false,
        priceAddPercentage: data[0]?.priceAddPercentage || null,

        image: data[0]?.image || "",
        splitBill: data[0]?.splitBill || false,
        hsnView: data[0]?.hsnView || false,
      });
    }
  }, [data]);
  const formatTimeToAMPM = (time) => {
    const formattedTime = new Date(`6000-01-01T${time}`);
    return formattedTime.toLocaleString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
  };

  console.log(formatTimeToAMPM(formData.happyHourFrom), "formData");

  const handleSubmit = async (e) => {
    if (!validateForm()) {
      toast.error("Please fill in all required fields.");
      return;
    }
    e.preventDefault();
    // Here you can send formData to your backend server or process it further
    console.log("Form submitted with data:", formData);

    // Reset form after submission
    setFormData({
      name: formData.name,
      adress: formData.adress,
      phoneNo: formData.phoneNo,
      email: formData.email,
      acNo: formData.acNo,
      ifsc: formData.ifsc,
      branch: formData.branch,
      website: formData.website,
      gstNo: formData.gstNo,
      gst: formData.gst,
      splitBill: formData.splitBill,

      image: imageURL,
      happyHour: formData.happyHour,
      happyHourDiscount: formData.happyHourDiscount,
      happyHourFrom: formatTimeToAMPM(formData.happyHourFrom),
      happyHourTo: formatTimeToAMPM(formData.happyHourTo),
      hsnView: formData.hsnView,
    });
  };
  console.log(formData, "formData");
  const save = async (e) => {
    if (!validateForm()) {
      toast.error("Please fill in all required fields.");
      return;
    }

    // Update formData with the latest imageURL before sending to the server
    const updatedFormData = {
      ...formData,
      image: imageURL, // Directly use the updated imageURL here
    };
    if (data.length > 0) {
      const updateData = {
        name: formData.name,
        adress: formData.adress,
        phoneNo: formData.phoneNo,
        email: formData.email,
        acNo: formData.acNo,
        ifsc: formData.ifsc,
        branch: formData.branch,
        website: formData.website,
        gstNo: formData.gstNo,
        gst: formData.gst,
        splitBill: formData.splitBill,
        happyHour: formData.happyHour,
        happyHourDiscount: formData.happyHourDiscount,
        happyHourFrom: formatTimeToAMPM(formData.happyHourFrom),
        happyHourTo: formatTimeToAMPM(formData.happyHourTo),
        priceAdd: formData.priceAdd,
        priceAddPercentage: formData.priceAddPercentage,
        hsnView: formData.hsnView,

        image: formData.image === "" || null ? imageURL : formData.image,
      };
      try {
        const response = await axios.put(
          `https://api.rasoi.launchlysoftware.in/api/updatePrintData/${customerId}/${id}`,
          { updatedData: updateData },
        );
        toast.success(response.data.message);
        setId("");
        window.location.reload();
      } catch (error) {
        if (error.response && error.response === 404) {
          toast.error(error.response.message);
        }
      }
    } else {
      try {
        const response = await axios.post(
          "https://api.rasoi.launchlysoftware.in/api/printRegister",
          {
            customerId: customerId,
            data: updatedFormData,
          },
        );

        console.log("Data Submitted: ", response.data);
        toast.success(response.data.message);

        // Reset form after submission
        setFormData({
          name: "",
          adress: "",
          phoneNo: "",
          email: "",
          acNo: "",
          ifsc: "",
          branch: "",
          website: "",
          gstNo: "",
          image: "",
          happyHour: false,
          happyHourDiscount: null,
          happyHourFrom: "",
          happyHourTo: "",
          hsnView: false,
        });
      } catch (error) {
        toast.error(error.message);
      }
    }
  };

  return (
    <Box
      bg="#f7f7f7"
      p="4"
      color="black"
      width="full"
      height="91vh"
      overflow="hidden"
      display="flex"
      flexDirection="column"
    >
      <Text fontSize="2xl" fontWeight="bold" mb={4} color="#0F3D2E">
        Restaurant Information
      </Text>
      <FormControl isRequired onSubmit={handleSubmit}>
        <Box overflowY="auto" maxH="calc(100vh - 150px)" pr={2}>
          <SimpleGrid columns={5} spacing={3}>
            <Box bg="white" p={3} borderRadius="md" boxShadow="sm">
              <FormLabel fontSize="xs" fontWeight="semibold" mb={1}>
                Restaurant Name
              </FormLabel>
              <Input
                size="sm"
                bg="white"
                border="1px solid #e2e8f0"
                _focus={{ borderColor: "#0F3D2E" }}
                placeholder="Enter Name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
              />
            </Box>
            <Box bg="white" p={3} borderRadius="md" boxShadow="sm">
              <FormLabel fontSize="xs" fontWeight="semibold" mb={1}>
                Phone
              </FormLabel>
              <Input
                size="sm"
                bg="white"
                border="1px solid #e2e8f0"
                _focus={{ borderColor: "#0F3D2E" }}
                placeholder="Enter Phone"
                name="phoneNo"
                value={formData.phoneNo}
                onChange={handleInputChange}
              />
            </Box>
            <Box bg="white" p={3} borderRadius="md" boxShadow="sm">
              <FormLabel fontSize="xs" fontWeight="semibold" mb={1}>
                Email
              </FormLabel>
              <Input
                size="sm"
                bg="white"
                border="1px solid #e2e8f0"
                _focus={{ borderColor: "#0F3D2E" }}
                placeholder="Enter Email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
              />
            </Box>
            <Box bg="white" p={3} borderRadius="md" boxShadow="sm">
              <FormLabel fontSize="xs" fontWeight="semibold" mb={1}>
                Website
              </FormLabel>
              <Input
                size="sm"
                bg="white"
                border="1px solid #e2e8f0"
                _focus={{ borderColor: "#0F3D2E" }}
                placeholder="Enter Website"
                name="website"
                value={formData.website}
                onChange={handleInputChange}
              />
            </Box>
            <Box bg="white" p={3} borderRadius="md" boxShadow="sm">
              <FormLabel fontSize="xs" fontWeight="semibold" mb={1}>
                GST Number
              </FormLabel>
              <Input
                size="sm"
                bg="white"
                border="1px solid #e2e8f0"
                _focus={{ borderColor: "#0F3D2E" }}
                placeholder="Enter GST"
                name="gstNo"
                value={formData.gstNo}
                onChange={handleInputChange}
              />
            </Box>
            <Box
              bg="white"
              p={3}
              borderRadius="md"
              boxShadow="sm"
              gridColumn="span 2"
            >
              <FormLabel fontSize="xs" fontWeight="semibold" mb={1}>
                Address
              </FormLabel>
              <Textarea
                size="sm"
                bg="white"
                border="1px solid #e2e8f0"
                _focus={{ borderColor: "#0F3D2E" }}
                placeholder="Enter Address"
                name="adress"
                value={formData.adress}
                onChange={handleInputChange}
                rows={2}
              />
            </Box>
            <Box bg="white" p={3} borderRadius="md" boxShadow="sm">
              <FormLabel fontSize="xs" fontWeight="semibold" mb={1}>
                Account Number
              </FormLabel>
              <Input
                size="sm"
                bg="white"
                border="1px solid #e2e8f0"
                _focus={{ borderColor: "#0F3D2E" }}
                placeholder="Enter A/C No"
                name="acNo"
                value={formData.acNo}
                onChange={handleInputChange}
              />
            </Box>
            <Box bg="white" p={3} borderRadius="md" boxShadow="sm">
              <FormLabel fontSize="xs" fontWeight="semibold" mb={1}>
                IFSC Code
              </FormLabel>
              <Input
                size="sm"
                bg="white"
                border="1px solid #e2e8f0"
                _focus={{ borderColor: "#0F3D2E" }}
                placeholder="Enter IFSC"
                name="ifsc"
                value={formData.ifsc}
                onChange={handleInputChange}
              />
            </Box>
            <Box bg="white" p={3} borderRadius="md" boxShadow="sm">
              <FormLabel fontSize="xs" fontWeight="semibold" mb={1}>
                Branch Name
              </FormLabel>
              <Input
                size="sm"
                bg="white"
                border="1px solid #e2e8f0"
                _focus={{ borderColor: "#0F3D2E" }}
                placeholder="Enter Branch"
                name="branch"
                value={formData.branch}
                onChange={handleInputChange}
              />
            </Box>
            <Box
              bg="white"
              p={3}
              borderRadius="md"
              boxShadow="sm"
              gridColumn="span 2"
            >
              <FormLabel fontSize="xs" fontWeight="semibold" mb={1}>
                Restaurant Logo
              </FormLabel>
              <Flex gap={2}>
                <Input
                  size="sm"
                  type="file"
                  bg="white"
                  border="1px solid #e2e8f0"
                  onChange={handleFileChange}
                />
                <Button
                  size="sm"
                  colorScheme="blue"
                  onClick={handlePost}
                  isLoading={uploading}
                >
                  Upload
                </Button>
              </Flex>
            </Box>
          </SimpleGrid>

          <Text fontSize="lg" fontWeight="bold" mt={4} mb={2} color="#0F3D2E">
            Settings
          </Text>
          <SimpleGrid columns={5} spacing={3}>
            <Box
              bg="white"
              p={3}
              borderRadius="md"
              boxShadow="sm"
              display="flex"
              alignItems="center"
            >
              <Checkbox
                name="gst"
                isChecked={formData.gst}
                onChange={handleCheckboxChange}
                colorScheme="red"
                size="sm"
              >
                Enable GST
              </Checkbox>
            </Box>
            <Box
              bg="white"
              p={3}
              borderRadius="md"
              boxShadow="sm"
              display="flex"
              alignItems="center"
            >
              <Checkbox
                name="splitBill"
                isChecked={formData.splitBill}
                onChange={handleCheckboxChange}
                colorScheme="red"
                size="sm"
              >
                Split Bill
              </Checkbox>
            </Box>
            <Box
              bg="white"
              p={3}
              borderRadius="md"
              boxShadow="sm"
              display="flex"
              alignItems="center"
            >
              <Checkbox
                name="hsnView"
                isChecked={formData.hsnView}
                onChange={handleCheckboxChange}
                colorScheme="red"
                size="sm"
              >
                HSN View
              </Checkbox>
            </Box>
            <Box
              bg="white"
              p={3}
              borderRadius="md"
              boxShadow="sm"
              display="flex"
              alignItems="center"
            >
              <Checkbox
                name="priceAdd"
                isChecked={formData.priceAdd}
                onChange={handleCheckboxChange}
                colorScheme="red"
                size="sm"
              >
                Price Add
              </Checkbox>
            </Box>
            {formData.priceAdd && (
              <Box bg="white" p={3} borderRadius="md" boxShadow="sm">
                <FormLabel fontSize="xs" fontWeight="semibold" mb={1}>
                  Add %
                </FormLabel>
                <Input
                  size="sm"
                  type="number"
                  bg="white"
                  border="1px solid #e2e8f0"
                  _focus={{ borderColor: "#0F3D2E" }}
                  placeholder="%"
                  name="priceAddPercentage"
                  value={formData.priceAddPercentage}
                  onChange={handleInputChange}
                />
              </Box>
            )}
          </SimpleGrid>

          <Text fontSize="lg" fontWeight="bold" mt={4} mb={2} color="#0F3D2E">
            Happy Hour Settings
          </Text>
          <SimpleGrid columns={5} spacing={3}>
            <Box
              bg="white"
              p={3}
              borderRadius="md"
              boxShadow="sm"
              display="flex"
              alignItems="center"
            >
              <Checkbox
                name="happyHour"
                isChecked={formData.happyHour}
                onChange={handleCheckboxChange}
                colorScheme="red"
                size="sm"
              >
                Enable Happy Hour
              </Checkbox>
            </Box>
            <Box bg="white" p={3} borderRadius="md" boxShadow="sm">
              <FormLabel fontSize="xs" fontWeight="semibold" mb={1}>
                Discount (%)
              </FormLabel>
              <Input
                size="sm"
                type="number"
                bg="white"
                border="1px solid #e2e8f0"
                _focus={{ borderColor: "#0F3D2E" }}
                placeholder="Discount"
                name="happyHourDiscount"
                value={formData.happyHourDiscount}
                onChange={handleInputChange}
              />
            </Box>
            <Box bg="white" p={3} borderRadius="md" boxShadow="sm">
              <FormLabel fontSize="xs" fontWeight="semibold" mb={1}>
                From Time
              </FormLabel>
              <Input
                size="sm"
                type="time"
                bg="white"
                border="1px solid #e2e8f0"
                _focus={{ borderColor: "#0F3D2E" }}
                name="happyHourFrom"
                value={formData.happyHourFrom}
                onChange={handleInputChange}
              />
            </Box>
            <Box bg="white" p={3} borderRadius="md" boxShadow="sm">
              <FormLabel fontSize="xs" fontWeight="semibold" mb={1}>
                To Time
              </FormLabel>
              <Input
                size="sm"
                type="time"
                bg="white"
                border="1px solid #e2e8f0"
                _focus={{ borderColor: "#0F3D2E" }}
                name="happyHourTo"
                value={formData.happyHourTo}
                onChange={handleInputChange}
              />
            </Box>
          </SimpleGrid>
        </Box>
        <Box mt={4} pb={4}>
          <Button
            type="submit"
            variant="solid"
            color="white"
            bg="#0F3D2E"
            _hover={{ color: "#0F3D2E", bg: "white" }}
            onClick={save}
          >
            {data && data.length > 0 ? "Update" : "Save"}
          </Button>
        </Box>
      </FormControl>
    </Box>
  );
};

export default PrintData;
